import React from 'react';
import { PageContainer, PageTitle, Card } from 'styles/common.styles';

const EmployeeCard = () => (
  <PageContainer>
    <PageTitle>인사카드</PageTitle>
    <Card style={{ padding: 24 }}>
      사원 기준일 스냅샷(조직·직급·호봉) 조회 화면 — APT-006. 인사마스터에서 상세 조회 PoC 완료 후 확장 예정.
    </Card>
  </PageContainer>
);

export default EmployeeCard;
